import React, { useEffect } from "react";
import GoBlue from "./../../../assets/images/blue_go.svg";
import { Link, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import TagManager from "react-gtm-module";
import { Tilt } from "react-tilt";
import Marquee from "react-fast-marquee";

export default function Clients( {k} ) {
  const { pathname } = useLocation();

  function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  }

  const logoFolderImages1 = importAll(
    require.context(
      `../../../../public/images/logo1`,
      false,
      /\.(png|jpe?g|svg)$/
    )
  );

  const logoFolderImages2 = importAll(
    require.context(
      `../../../../public/images/logo2`,
      false,
      /\.(png|jpe?g|svg)$/
    )
  );


  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  }, []);

  const handleViewAllClients = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "Home View All Clients Click",
      },
    });
  };

  const defaultOptions = {
    reverse: false,
    max: 35,
    perspective: 1000,
    scale: 1.1,
    speed: 7000,
    transition: true,
    axis: null,
    reset: true,
    easing: "cubic-bezier(.03,.98,.52,.99)",
  };

  return (
    <section
      className="clients"
      style={{ paddingTop: (pathname === "/about" || pathname === "/our-clients") ? "120px" : 0 , backgroundColor: "white", paddingTop: "40px" }}
    >

      <div className="container">
        <div className="row">
          <div className={` ${k === 'A' ? "col-md-12" : "col-md-6"}`}>
            <div className="heading" data-aos="fade-up">
              <div className="title" style={{textAlign: k === 'A' ? "center" : ""}}>Our Clients</div>
              <div className="des" style={{textAlign: k === 'A' ? "center" : ""}}>We Work With Global Top Brands.</div>
            </div>
          </div>
          {k !== 'A' && (
            <div className="col-md-6">
              <div
                className="client_desc"
              data-aos="fade-up"
              data-aos-anchor-placement="bottom-bottom"
            >
              <p>
                We've gained our clients' trust through our work, leading to an 89% repeat client rate. We build almost every type of application—just name it, and we'll create it with care and expertise.
              </p>
            </div>
          </div>
          )}
          {/* <div className="col-md-1"></div> */}
          <div className="col-md-12">
            {/* <div className="client_wrapper">
              {logoFolderImages &&
                Object.values(logoFolderImages).length > 0 &&
                Object.values(logoFolderImages).map((v, i) => {
                  if (i >= 12) {
                    return;
                  } else {
                    return (
                      <div className="client_logo" data-aos="zoom-in-left">
                        <img src={v} alt="" />
                      </div>
                    )
                  }
                })}
            </div> */}
            <div className="row client_wrapper">
              {/* First row of logos - right to left */}
              <div className="col-12 mb-4">
                <Marquee gradient={false} speed={200} pauseOnHover={true} direction="left">
                  {Object.values(logoFolderImages1).map((v, i) => (
                    <Tilt options={defaultOptions} key={i}>
                      <div className="client_logo">
                        <img className="w-100" src={v} alt="" />
                      </div>
                    </Tilt>
                  ))}
                </Marquee>
              </div>
              {/* Second row of logos - left to right */}
              <div className="col-12">
                <Marquee gradient={false} speed={200} pauseOnHover={true} direction="right">
                  {Object.values(logoFolderImages2).map((v, i) => (
                    <Tilt options={defaultOptions} key={i}>
                      <div className="client_logo">
                        <img className="w-100" src={v} alt="" />
                      </div>
                    </Tilt>
                  ))}
                </Marquee>
              </div>
            </div>
          </div>
          {/* <div className="col-md-1"></div> */}
          {/* <div className="col-md-12">
            <div className="client_desc" data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom">
              <p>
                We win our client's trust for the work they provided us. We have
                a 89% repititive client ratio. We make almost every genre of
                applications. You name it and we build it.
              </p>
            </div>
            <div className="view_all">
              <Link to="our-clients" onClick={handleViewAllClients}>
                View All Clients <img src={GoBlue} alt="" />
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
